import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import useTranslations from "hooks/useTranslations"
import NumberedList from "components/organisms/common/NumberedList"

const StepsSchoolsImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      conversationImage: file(
        relativePath: { eq: "schools/AdobeStock_88681735.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 1200)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.conversationImage)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "right center",
      }}
      className={className}
    />
  )
}

export default function HowDoWeHelpSchools(props) {
  const {
    schoolHowDoWeHelpTitle,
    schoolHelpListItem1,
    schoolHelpListItem2,
    schoolHelpListItem3,
  } = useTranslations()

  const items = [
    {
      number: 1,
      title: schoolHelpListItem1,
      numberColor: "text-kkm-yellow",
    },
    {
      number: 2,
      title: schoolHelpListItem2,
      numberColor: "text-kkm-yellow",
    },
    {
      number: 3,
      title: schoolHelpListItem3,
      numberColor: "text-kkm-yellow",
    },
  ]

  return (
    <NumberedList
      title={schoolHowDoWeHelpTitle}
      items={items}
      Image={StepsSchoolsImage}
      reversed
      {...props}
    />
  )
}
